// Router bridge to inject router after creation
let routerRef = null;

export function provideRouter(router) {
  routerRef = router;
}

export function getRouter() {
  return routerRef;
}
